import Select, { SingleValue, ActionMeta } from 'react-select';

import styles from './dropdown.module.scss';

type SelectOptionType = { label: string; value: string };

interface IProps {
  options: any;
  isSearchable?: boolean;
  label?: string;
  value?: SelectOptionType;
  defaultValue?: SelectOptionType;
  onChange: (
    value: SingleValue<SelectOptionType>,
    actionMeta: ActionMeta<SelectOptionType>
  ) => void;
}

const Dropdown = ({
  options,
  isSearchable = false,
  label,
  value,
  defaultValue,
  onChange
}: IProps) => {
  const customStyles = {
    clearIndicator: (provided: any, state: any) => ({
      ...provided
    }),
    container: (provided: any, state: any) => ({
      ...provided
    }),
    control: (provided: any, state: any) => ({
      ...provided,
      boxShadow: 'none',
      padding: '0',
      cursor: 'pointer'
    }),
    dropdownIndicator: (provided: any, state: any) => ({
      ...provided
    }),
    group: (provided: any, state: any) => ({
      ...provided
    }),
    groupHeading: (provided: any, state: any) => ({
      ...provided
    }),
    indicatorsContainer: (provided: any, state: any) => ({
      ...provided,
      path: {
        fill: '#94999e'
      }
    }),
    indicatorSeparator: (provided: any, state: any) => ({
      ...provided,
      display: 'none'
    }),
    input: (provided: any, state: any) => ({
      ...provided,
      margin: '0',
      padding: '0'
    }),
    loadingIndicator: (provided: any, state: any) => ({
      ...provided
    }),
    loadingMessage: (provided: any, state: any) => ({
      ...provided
    }),
    menu: (provided: any, state: any) => ({
      ...provided,
      border: '1px solid #94999e',
      borderRadius: '0',
      boxShadow: 'none',
      padding: '16px 0',
      width: '200px',
      margin: 0,
      right: 0,
      zIndex: 2
    }),
    menuList: (provided: any, state: any) => ({
      ...provided,
      border: 'none'
    }),
    menuPortal: (provided: any, state: any) => ({
      ...provided
    }),
    multiValue: (provided: any, state: any) => ({
      ...provided
    }),
    multiValueLabel: (provided: any, state: any) => ({
      ...provided
    }),
    multiValueRemove: (provided: any, state: any) => ({
      ...provided
    }),
    noOptionsMessage: (provided: any, state: any) => ({
      ...provided
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#f6f7f9' : '#fff',
      backgroundPosition: '90% center',
      backgroundRepeat: 'no-repeat',
      color: '#2b363b',
      font: 'normal 400 14px "Roboto", Arial, Helvetica, sans-serif',
      padding: '10px 24px',
      cursor: 'pointer',
      '&:active': {
        backgroundColor: '#f6f7f9'
      }
    }),
    placeholder: (provided: any, state: any) => ({
      ...provided
    }),
    singleValue: (provided: any, state: any) => {
      return {
        ...provided,
        fontFamily: 'Roboto',
        fontSize: 14,
        margin: '0',
        padding: '10px 15px',
        color: 'black',
        minWidth: '150px'
      };
    },
    valueContainer: (provided: any, state: any) => ({
      ...provided,
      padding: '0'
    })
  };

  return (
    <div className={styles.dropdown}>
      <div className={styles.container}>
        <label id="season-filter" className={styles.dropdownLabel}>
          {label} :
        </label>
        <Select
          data-testid="PT-dropdown-select"
          aria-labelledby="dropdown-select"
          options={options}
          value={value}
          defaultValue={defaultValue}
          isSearchable={isSearchable}
          styles={customStyles}
          onChange={onChange}
        />
      </div>
    </div>
  );
};

export default Dropdown;
